// initial state
const state = () => ({
  cityName:"城市名"
})

// getters
const getters = {
    getCityFn(state){
      return state.cityName;
    }
}

// actions
const actions = {
    setCityName({commit,state}, name){
        // 跟后台打交道
        // 调用mutaions里面的方法
        commit("setCity", name);
    }
}

// mutations
const mutations = {
    setCity(state, name){
        state.cityName = name;//将传参设置给state的city
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}